<template>
  <div class="BackendList">
    <el-table
        height="600"
        class="table"
        :data="list">
      <!--      <el-table-column-->
      <!--          label="Avatar"-->
      <!--          width="100">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-image-->
      <!--              style="width: 60px; height: 60px"-->
      <!--              :src="scope.row.user_avatar"-->
      <!--              fit="cover"></el-image>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column
          prop="user_name"
          label="Name"
          width="100">
      </el-table-column>

      <el-table-column
          prop="user_email"
          label="Email"
          width="200">
      </el-table-column>
      <el-table-column
          prop="user_role"
          label="Role"
          width="100">
      </el-table-column>
      <el-table-column
          label="Rate"
          width="100">
        <template slot-scope="scope">
          <i :class="scope.row.rate_enable?'el-icon-check':'el-icon-close'"></i>
        </template>
      </el-table-column>
      <el-table-column
          label="Comment"
          width="100">
        <template slot-scope="scope">
          <i :class="scope.row.review_enable?'el-icon-check':'el-icon-close'"></i>
        </template>
      </el-table-column>
      <el-table-column
          label="Video"
          width="100">
        <template slot-scope="scope">
          <i :class="scope.row.video_enable?'el-icon-check':'el-icon-close'"></i>
        </template>
      </el-table-column>
      <el-table-column
          width="150">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="primary"
              @click="onEdit(scope.row.user_id)">Edit
          </el-button>
          <el-button
              size="mini"
              type="danger"
              :disabled="scope.row.user_self"
              @click="onDelete(scope.row.user_id)">Delete
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
        title="Edit User"
        custom-class="popup_user"
        :visible.sync="dialog_visible"
        width="30%">
      <BackendCreate v-if="dialog_visible" :uid="current_id" @update="onUpdate"></BackendCreate>
    </el-dialog>
  </div>
</template>

<script>
  import BackendCreate from "@/components/Management/BackendCreate/BackendCreate";
  import {deleteBackendUser} from "@/utils/api";

  export default {
    components:{
      BackendCreate
    },
    props: ['list'],
    data: () => {
      return {
        dialog_visible:false,
        backend_list: [],
        current_id:''
      }
    },
    methods: {
      onUpdate(){
        this.dialog_visible = false;
        this.$emit('update')
      },
      onEdit(id) {
        this.current_id = id;
        this.dialog_visible = true
      },
      onDelete(id) {
        this.$confirm(`Are you sure you want to delete this user?`, 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {
          deleteBackendUser(id).then(() => {
            this.$emit('update')
          })
        }).catch(() => {});
      }
    },
    beforeMount() {

    }
  };
</script>

<style lang="scss" scoped>
  @import "_BackendList.scss";
</style>